export function createReducerBySpec(actionsSpec, initialState) {
  // eslint-disable-next-line default-param-last
  return function reducer(state = initialState, action) {
    const { type } = action;
    const reaction = actionsSpec[type];

    return reaction ? reaction(state, action) : state;
  };
}

export function reducerFactory(actionsSpec, initialState) {
  const actionTypes = Object.keys(actionsSpec)?.reduce((res, actionType) => {
    res[actionType] = actionType;

    return res;
  }, {});

  return {
    reducer: createReducerBySpec(actionsSpec, initialState),
    actionTypes,
  };
}
